<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    width="1200"
  >
    <v-card width="1200" class="mx-auto">
      <v-toolbar>
        <v-toolbar-title class="title">
          <span>
            {{ $t("promotionUseDetail") }}
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-6 pt-4">
        <div v-if="loadingPromotionDetail">
          <v-skeleton-loader
            type="table-heading, table-thead, table-row-divider@3, table-tfoot"
          />
        </div>
        <div v-else>
          <v-text-field
            class="mx-2 mb-2"
            v-model="search"
            :label="$t('search')"
            append-icon="mdi-magnify"
            single-line
            hide-details
          ></v-text-field>
          <v-data-table
            :search="search"
            :items="data"
            :headers="headers"
            item-key="keyId"
          >
            <template v-slot:item.id_promo="{ item }">
              <v-btn @click="$copy(item.id_promo)" small>
                {{ item.id_promo }}
              </v-btn>
            </template>
            <template v-slot:item.valor_lancamento="{ item }">
              {{ $t("labelCurrency") }} {{ item.valor_lancamento }}
            </template>
            <template v-slot:item.data_lancamento="{ item }">
              {{ item.data_lancamento }}
            </template>
            <template v-slot:item.valor="{ item }">
              {{ $t("labelCurrency") }} {{ item.valor }}
            </template>
            <template v-slot:item.saldo_anterior="{ item }">
              <v-icon v-if="item.id_operacao == '16'">
                mdi-dots-horizontal
              </v-icon>
              <span v-else>
                {{ $t("labelCurrency") }}
                {{ item.saldo_anterior }}
              </span>
            </template>
            <template v-slot:item.saldo_posterior="{ item }">
              <v-icon v-if="item.id_operacao == '16'">
                mdi-dots-horizontal
              </v-icon>
              <span v-else>
                {{ $t("labelCurrency") }}
                {{ item.saldo_posterior }}
              </span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                :disabled="loadingBetId == item.id_promo ||
                  item.id_operacao != '7'
                "
                :loading="loadingBetId == item.id_promo"
                light
                small
                @click="seeBet(item.id_promo)"
              >
                <span v-show="$vuetify.breakpoint.smAndDown">
                  {{ $t("show") }}
                </span>
                <v-icon :right="$vuetify.breakpoint.smAndDown" size="24">
                  mdi-magnify-plus-outline
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>

    <DialogBetOnline />
  </v-dialog>
</template>
<script>
import DialogBetOnline from "../../_components/dialog-bet-online/dialog-bet-online.vue";

export default {
  props: ["dialog", "promotion"],

  data: () => ({
    loadingPromotionDetail: false,
    data: [],
    search: "",
    loadingBetId: 0,
  }),

  components: { DialogBetOnline },

  watch: {
    dialog(val) {
      if (val) {
        this.fetchPromotionDetail(this.promotion.promotion_id);
      } else {
        this.data = [];
        this.search = "";
      }
    },
  },

  computed: {
    headers() {
      return [
        {
          text: "ID",
          value: "id_promo",
        },
        {
          text: this.$t("operationName"),
          value: "nome_operacao",
        },
        {
          text: this.$t("date"),
          value: "data_lancamento",
        },
        {
          text: this.$t("value"),
          value: "valor",
        },
        {
          text: this.$t("previous_balance"),
          value: "saldo_anterior",
        },
        {
          text: this.$t("nextBalance"),
          value: "saldo_posterior",
        },
        {
          text: this.$t("actions"),
          value: "actions",
          sortable: false,
          filterable: false,
        },
      ];
    },
  },

  methods: {
    fetchPromotionDetail(id_promo) {
      this.loadingPromotionDetail = true;

      this.$axios
        .post(
          "/player/bonus/promotion/listEntrysByUserPromos",
          this.$formdata({ id_promo })
        )
        .then((res) => {
          this.data = res.data.dados.map((item) => ({
            ...item,
            keyId: `${item.id_promo}-${item.id_operacao}`,
            data_lancamento: new Date(
              item.data_lancamento.replace(" ", "T")
            ).toLocaleDateString([], {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            }),
          }));
          this.loadingPromotionDetail = false;
        })
        .catch((err) => {
          this.$emit("closeDialog");

          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        });
    },

    seeBet(bet_id) {
      this.loadingBetId = bet_id;

      this.$axios
        .post("/player/online/betsOnline/getBet", this.$formdata({ bet_id }))
        .then((res) => {
          this.$store.commit("showBetDialog", {
            status: true,
            value: { ...res.data.dados.apostas[0], hideShareBet: true },
          });
        })
        .finally(() => {
          this.loadingBetId = 0;
        });
    },

    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>
